export default theme => ({
    iconWrapper: {
        padding: theme.spacing(0, 2, 0, 0),
        borderRight: '1px solid #ccc',
        display: 'inline-block',
    },
});
